module.exports = __webpack_public_path__ + "static/media/reliquia-virgen-coromoto-medidas.5f80da8e.jpg";